var map = {
	"./anecdotes.png": 221,
	"./anodot.png": 222,
	"./anodot@2x.png": 66,
	"./autoleadstar.png": 223,
	"./bringg.png": 224,
	"./bringg@2x.png": 67,
	"./centrical.png": 225,
	"./colu.png": 226,
	"./colu@2x.png": 68,
	"./compete.png": 227,
	"./coralogix.png": 228,
	"./daisy.png": 229,
	"./fabric.png": 230,
	"./fabric@2x.png": 69,
	"./frank.png": 231,
	"./frank@2x.png": 70,
	"./freightos@2x.png": 71,
	"./healthy.io@2x.png": 72,
	"./honeybook@2x.png": 73,
	"./joytunes.png": 232,
	"./joytunes@2x.png": 74,
	"./lawgeex.png": 233,
	"./lawgeex@2x.png": 75,
	"./lemonade.png": 234,
	"./lemonade@2x.png": 76,
	"./melio.png": 235,
	"./multinarity.png": 236,
	"./myinterview.png": 237,
	"./nexar.png": 238,
	"./nexar@2x.png": 77,
	"./panorays.png": 239,
	"./placeholder.png": 29,
	"./placer.png": 64,
	"./platterz.png": 240,
	"./platterz@2x.png": 78,
	"./riseup.png": 241,
	"./securithings.png": 242,
	"./sparkbeyond@2x.png": 79,
	"./thriver.png": 243,
	"./tinytap@2x.png": 80,
	"./uniper.png": 65,
	"./unit.png": 244,
	"./wework@2x.png": 81,
	"./windward.png": 245,
	"./windward@2x.png": 82,
	"./workiz.png": 246,
	"./workiz@2x.png": 83
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;


//////////////////
// WEBPACK FOOTER
// ./src/assets/companies ^\.\/.*\.png$
// module id = 220
// module chunks = 0